import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-26866ac2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"display":"flex","justify-content":"center","align-items":"center","flex-direction":"column","z-index":"10"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { style: {"color":"white","font-size":"10px"} }, "MENÚ", -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["href"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 4 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 5 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 6 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 7 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 8 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 9 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["href"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 10 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 2,
  class: "spacer"
}
const _hoisted_35 = { key: 3 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, " Tienda", -1))
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_41 = { key: 4 }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 2 }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_51 = { key: 5 }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 2 }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_62 = { key: 6 }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_75 = { key: 7 }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { key: 1 }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { key: 2 }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { key: 3 }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { key: 0 }
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { key: 0 }
const _hoisted_95 = /*#__PURE__*/_createStaticVNode("<div class=\"spacer\" data-v-26866ac2></div><div class=\"spacer\" data-v-26866ac2></div><div class=\"spacer\" data-v-26866ac2></div><div class=\"spacer\" data-v-26866ac2></div><div class=\"spacer\" data-v-26866ac2></div><div class=\"spacer\" data-v-26866ac2></div>", 6)
const _hoisted_101 = {
  key: 8,
  class: "no-auth"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_103 = { key: 0 }
const _hoisted_104 = { class: "primary" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "General", -1))
const _hoisted_109 = ["href"]
const _hoisted_110 = { key: 0 }
const _hoisted_111 = { key: 1 }
const _hoisted_112 = { key: 2 }
const _hoisted_113 = { key: 3 }
const _hoisted_114 = { key: 4 }
const _hoisted_115 = { key: 5 }
const _hoisted_116 = { key: 6 }
const _hoisted_117 = { key: 7 }
const _hoisted_118 = { key: 8 }
const _hoisted_119 = { key: 9 }
const _hoisted_120 = ["href"]
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Soporte técnico", -1))
const _hoisted_122 = { key: 10 }
const _hoisted_123 = {
  key: 1,
  class: "spacer"
}
const _hoisted_124 = { key: 2 }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Tienda", -1))
const _hoisted_126 = { key: 0 }
const _hoisted_127 = { key: 1 }
const _hoisted_128 = { key: 2 }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_130 = { key: 3 }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Foro", -1))
const _hoisted_132 = { key: 0 }
const _hoisted_133 = { key: 1 }
const _hoisted_134 = { key: 2 }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_136 = { key: 4 }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Empleo", -1))
const _hoisted_138 = { key: 0 }
const _hoisted_139 = { key: 1 }
const _hoisted_140 = { key: 2 }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_142 = { key: 5 }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Social", -1))
const _hoisted_144 = { key: 0 }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_146 = { key: 6 }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Mi sección", -1))
const _hoisted_148 = { key: 0 }
const _hoisted_149 = { key: 1 }
const _hoisted_150 = { key: 2 }
const _hoisted_151 = { key: 3 }
const _hoisted_152 = {
  key: 7,
  class: "no-auth"
}
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

import { useAuth } from '@/store/useAuth'
import AuthBtn from '../buttons/AuthBtn.vue'
import { useMenu } from '@/store/useMenu'
import useWindowWidth from '@/composables/useWindowWidth'
import router from '@/router'
import { ref, onMounted } from 'vue'
import ProfileService from '@/services/ProfileService'
import main from '@/data/main.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuBar',
  setup(__props) {


const store = useAuth()
const storeMenu = useMenu()
const { windowWidth } = useWindowWidth()
const collapse = ref(true)
const expand = ref(false)
const userId = ref('')
const userFull:any = ref({})
const profileService = new ProfileService()
const loading = ref(true)


onMounted(async () => {
    loading.value = true

    if (!store.token) {
        loading.value = false
        return
    }

    userFull.value = await profileService.MyUser(store.token)
    userId.value = userFull.value.id
    loading.value = false
})

const handleCollapse = () => {
    collapse.value = true
    expand.value = false
}

const handleExpand = () => {
    collapse.value = false
    expand.value = true
}

const handleLogout = () => {
    storeMenu.isOpen = false
    store.logout()
    router.push({ name: 'auth' })
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(windowWidth) > 950)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({ 'animate': true, 'container': expand.value, 'min-container': collapse.value }),
          style: {"overflow-y":"scroll"},
          onMouseenter: handleExpand,
          onMouseleave: handleCollapse
        }, [
          (collapse.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_icon, {
                  name: "ri-menu-unfold-fill",
                  scale: "1",
                  fill: "white"
                }),
                _hoisted_2
              ]))
            : _createCommentVNode("", true),
          (expand.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                (expand.value)
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_5, "General"))
                  : (_openBlock(), _createElementBlock("hr", _hoisted_6)),
                _createElementVNode("nav", null, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'home' },
                        class: "link"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "md-home-sharp",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(),
                          (expand.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Inicio"))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: _unref(main).SCHOOL_URL,
                        target: "_blank",
                        class: "link"
                      }, [
                        _createVNode(_component_v_icon, {
                          name: "ai-ads",
                          class: "icon",
                          hover: "true",
                          animation: "wrench"
                        }),
                        _createTextVNode(),
                        (expand.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Conoce el centro"))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_8)
                    ]),
                    (_unref(main).has_module_news)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'notifications' },
                            class: "link"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "io-newspaper-sharp",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(),
                              (expand.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Noticias Escuelas Ave María"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(main).has_module_news)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'agenda' },
                            class: "link"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "bi-calendar3",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(),
                              (expand.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Agenda"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(main).has_module_roadmap)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'roadmaps' },
                            class: "link"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "md-route-twotone",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(),
                              (expand.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Itinerarios Formativos"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(main).has_module_course)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'courses' },
                            class: "link"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "gi-teacher",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(),
                              (expand.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Cursos Formativos"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(main).has_module_certification)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'certifications' },
                            class: "link"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "gi-diploma",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(),
                              (expand.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Certificaciones"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(main).has_module_bootcamp)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'bootcamp' },
                            class: "link"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "md-developermode",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(),
                              (expand.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "BootCamps"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(main).has_module_webinar)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'webinar' },
                            class: "link"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "fa-laptop-code",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(),
                              (expand.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Webinars"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(main).has_module_challenge)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'challens' },
                            class: "link"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "bi-cast",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(),
                              (expand.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Reto de la Semana"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(main).has_module_manual)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'bookspdf' },
                            class: "link"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "bi-book-half",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(),
                              (expand.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Manuales"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(main).has_module_exercise)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'ejercicios' },
                            class: "link"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "md-librarybooks-round",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(),
                              (expand.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Ejercicios"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: `mailto:${_unref(main).EMAIL_ADMINISTRATION}`,
                        class: "link",
                        target: "_blank"
                      }, [
                        _createVNode(_component_v_icon, {
                          name: "md-supportagent-twotone",
                          class: "icon",
                          hover: "true",
                          animation: "wrench"
                        }),
                        (expand.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Soporte técnico"))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_30)
                    ]),
                    (_unref(main).has_module_faqs)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'faqs' },
                            class: "link"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "bi-question-square",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(),
                              (expand.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, "FAQs"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_unref(main).has_module_shop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34))
                  : _createCommentVNode("", true),
                (_unref(main).has_module_shop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("nav", null, [
                        _createElementVNode("ul", null, [
                          (_unref(main).has_module_class)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
                                _createVNode(_component_RouterLink, {
                                  to: { name: 'teacher' },
                                  class: "link",
                                  onClick: _unref(storeMenu).toggleMenu
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      name: "gi-teacher",
                                      class: "icon",
                                      hover: "true",
                                      animation: "wrench"
                                    }),
                                    _createTextVNode(" Clases En Vivo ")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(main).has_module_bookshop)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                                _createVNode(_component_RouterLink, {
                                  to: { name: 'bookshop' },
                                  class: "link",
                                  onClick: _unref(storeMenu).toggleMenu
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      name: "bi-book-fill",
                                      class: "icon",
                                      hover: "true",
                                      animation: "wrench"
                                    }),
                                    _createTextVNode(" Librería ")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(main).has_module_shop)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                                _createVNode(_component_RouterLink, {
                                  to: { name: 'shop' },
                                  class: "link",
                                  onClick: _unref(storeMenu).toggleMenu
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      name: "hi-shopping-cart",
                                      class: "icon",
                                      hover: "true",
                                      animation: "wrench"
                                    }),
                                    _createTextVNode(" Tienda ")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_40,
                (_unref(main).has_module_forum)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      (expand.value)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_42, "Foro"))
                        : (_openBlock(), _createElementBlock("hr", _hoisted_43)),
                      _createElementVNode("nav", null, [
                        _createElementVNode("ul", null, [
                          (_unref(main).has_module_questions)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_44, [
                                _createVNode(_component_RouterLink, {
                                  to: { name: 'forum' },
                                  class: "link"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      name: "bi-question-circle-fill",
                                      class: "icon",
                                      hover: "true",
                                      animation: "wrench"
                                    }),
                                    _createTextVNode(),
                                    (expand.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_45, "Dudas y Preguntas"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(store).token && _unref(main).has_module_my_questions)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_46, [
                                _createVNode(_component_RouterLink, {
                                  to: { name: 'my-questions' },
                                  class: "link"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      name: "si-dialogflow",
                                      class: "icon",
                                      hover: "true",
                                      animation: "wrench"
                                    }),
                                    _createTextVNode(),
                                    (expand.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, "Mis Preguntas"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(main).has_module_last_questions)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_48, [
                                _createVNode(_component_RouterLink, {
                                  to: { name: 'forum-latest-questions' },
                                  class: "link"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      name: "md-lineweight-twotone",
                                      class: "icon",
                                      hover: "true",
                                      animation: "wrench"
                                    }),
                                    _createTextVNode(),
                                    (expand.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Últimas Preguntas"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_50,
                (_unref(main).has_module_employment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      (expand.value)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_52, "Empleo"))
                        : (_openBlock(), _createElementBlock("hr", _hoisted_53)),
                      _createElementVNode("nav", null, [
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", null, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'job-offering' },
                              class: "link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "md-workhistory",
                                  class: "icon",
                                  hover: "true",
                                  animation: "wrench"
                                }),
                                _createTextVNode(),
                                (expand.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_54, "Ofertas de Empleo"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          (_unref(store).token)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_55, [
                                _createVNode(_component_RouterLink, {
                                  to: { name: 'job-profile' },
                                  class: "link"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      name: "bi-person-workspace",
                                      class: "icon",
                                      hover: "true",
                                      animation: "wrench"
                                    }),
                                    _createTextVNode(),
                                    (expand.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_56, "Mi Perfil de Empleo"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(main).has_module_practice)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_57, [
                                _createVNode(_component_RouterLink, {
                                  to: { name: 'project-offering' },
                                  class: "link"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      name: "io-book",
                                      class: "icon",
                                      hover: "true",
                                      animation: "wrench"
                                    }),
                                    _createTextVNode(),
                                    (expand.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_58, "Ofertas de Prácticas"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(store).token)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_59, [
                                _createVNode(_component_RouterLink, {
                                  to: { name: 'my-candidatures' },
                                  class: "link"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      name: "gi-tabletop-players",
                                      class: "icon",
                                      hover: "true",
                                      animation: "wrench"
                                    }),
                                    (expand.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_60, "Mis Candidaturas"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_61,
                (_unref(store).token && _unref(main).has_module_social)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      (expand.value)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_63, "Social"))
                        : (_openBlock(), _createElementBlock("hr", _hoisted_64)),
                      _createElementVNode("nav", null, [
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", null, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'my-wall' },
                              class: "link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "si-coderwall",
                                  class: "icon",
                                  hover: "true",
                                  animation: "wrench"
                                }),
                                _createTextVNode(),
                                (expand.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_65, "Mi Muro"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'hall-of-fame' },
                              class: "link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "md-stars-round",
                                  class: "icon",
                                  hover: "true",
                                  animation: "wrench"
                                }),
                                _createTextVNode(),
                                (expand.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_66, "Salón De La Fama"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          (_unref(main).has_module_message)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_67, [
                                _createVNode(_component_RouterLink, {
                                  to: { name: 'messages' },
                                  class: "link"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      name: "ri-message-2-fill",
                                      class: "icon",
                                      hover: "true",
                                      animation: "wrench"
                                    }),
                                    _createTextVNode(),
                                    (expand.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_68, "Mensajería"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("li", null, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'friends' },
                              class: "link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "fa-user-friends",
                                  class: "icon",
                                  hover: "true",
                                  animation: "wrench"
                                }),
                                _createTextVNode(),
                                (expand.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_69, "Mis Amigos"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'social-profile-edit' },
                              class: "link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "fa-user-edit",
                                  class: "icon",
                                  hover: "true",
                                  animation: "wrench"
                                }),
                                _createTextVNode(),
                                (expand.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_70, "Gestionar Mi Canal"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'my-reputation' },
                              class: "link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "ri-medal-fill",
                                  class: "icon",
                                  hover: "true",
                                  animation: "wrench"
                                }),
                                _createTextVNode(),
                                (expand.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_71, "Mi Reputación "))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          (_unref(main).has_module_discord)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_72, [
                                _createElementVNode("a", {
                                  href: "https://discord.com/invite/D6CTQyrf9Q",
                                  target: "blank",
                                  class: "link",
                                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(storeMenu).toggleMenu && _unref(storeMenu).toggleMenu(...args)))
                                }, [
                                  _createVNode(_component_v_icon, {
                                    name: "bi-discord",
                                    class: "icon",
                                    hover: "true",
                                    animation: "wrench"
                                  }),
                                  _createTextVNode(),
                                  (expand.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_73, "Cafetería del Campus"))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_74,
                (_unref(store).token)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                      (expand.value)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_76, "Mi sección"))
                        : (_openBlock(), _createElementBlock("hr", _hoisted_77)),
                      _createElementVNode("nav", null, [
                        _createElementVNode("ul", null, [
                          (userFull.value.paypal_id && _unref(main).monetization_type === 'subscription')
                            ? (_openBlock(), _createElementBlock("li", _hoisted_78, [
                                _createVNode(_component_RouterLink, {
                                  to: { name: 'count-prodev' },
                                  class: "link"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      name: "md-workspacepremium-sharp",
                                      class: "icon",
                                      hover: "true",
                                      animation: "wrench"
                                    }),
                                    (expand.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_79, "Mi Suscripción"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (userFull.value.paypal_id && _unref(main).monetization_type === 'subscription')
                            ? (_openBlock(), _createElementBlock("li", _hoisted_80, [
                                _createVNode(_component_RouterLink, {
                                  to: { name: 'register-free' },
                                  class: "link"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      name: "md-workspacepremium-sharp",
                                      class: "icon",
                                      hover: "true",
                                      animation: "wrench"
                                    }),
                                    (expand.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_81, "Comenzar Prueba Gratuita"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(main).monetization_type == 'pay_per_course')
                            ? (_openBlock(), _createElementBlock("li", _hoisted_82, [
                                _createVNode(_component_RouterLink, {
                                  to: { name: 'shop-course' },
                                  class: "link"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      name: "fa-shopping-bag",
                                      class: "icon",
                                      hover: "true",
                                      animation: "wrench"
                                    }),
                                    (expand.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_83, "Mis Compras"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (!loading.value && _unref(main).has_module_portfolio)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_84, [
                                (_unref(store).token)
                                  ? (_openBlock(), _createBlock(_component_RouterLink, {
                                      key: 0,
                                      to: { name: 'portfolio2', params: { id: userId.value } },
                                      class: "link",
                                      onClick: _unref(storeMenu).toggleMenu,
                                      target: "_blank"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          name: "fa-portrait",
                                          class: "icon",
                                          hover: "true",
                                          animation: "wrench"
                                        }),
                                        _createTextVNode(" Mi Portfolio ")
                                      ]),
                                      _: 1
                                    }, 8, ["to", "onClick"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("li", null, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'my-roadmaps' },
                              class: "link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "md-route-twotone",
                                  class: "icon",
                                  hover: "true",
                                  animation: "wrench"
                                }),
                                _createTextVNode(),
                                (expand.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_85, "Mis Itinerarios Formativos"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'my-courses' },
                              class: "link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "gi-teacher",
                                  class: "icon",
                                  hover: "true",
                                  animation: "wrench"
                                }),
                                _createTextVNode(),
                                (expand.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_86, "Mis Cursos Formativos"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'my-diplomas' },
                              class: "link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "gi-diploma",
                                  class: "icon",
                                  hover: "true",
                                  animation: "wrench"
                                }),
                                _createTextVNode(),
                                (expand.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_87, "Mis Diplomas"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'my-notes' },
                              class: "link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "md-notes",
                                  class: "icon",
                                  hover: "true",
                                  animation: "wrench"
                                }),
                                _createTextVNode(),
                                (expand.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_88, "Mis Apuntes"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'my-favs' },
                              class: "link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "md-playlesson-round",
                                  class: "icon",
                                  hover: "true",
                                  animation: "wrench"
                                }),
                                _createTextVNode(),
                                (expand.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_89, "Mis Lecciones Favoritas"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'my-laters' },
                              class: "link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "md-watchlater",
                                  class: "icon",
                                  hover: "true",
                                  animation: "wrench"
                                }),
                                _createTextVNode(),
                                (expand.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_90, "Ver Más Tarde"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'codebites-saved' },
                              class: "link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "bi-file-code-fill",
                                  class: "icon",
                                  hover: "true",
                                  animation: "wrench"
                                }),
                                _createTextVNode(),
                                (expand.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_91, "Shorts Guardados"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'codeposts-saved' },
                              class: "link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "bi-file-post",
                                  class: "icon",
                                  hover: "true",
                                  animation: "wrench"
                                }),
                                _createTextVNode(),
                                (expand.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_92, "Posts Guardados"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_RouterLink, {
                              to: { name: 'profile' },
                              class: "link"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "la-user-circle",
                                  class: "icon",
                                  hover: "true",
                                  animation: "wrench"
                                }),
                                _createTextVNode(),
                                (expand.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_93, "Mi Perfil"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_RouterLink, {
                              to: "#",
                              class: "link",
                              onClick: _withModifiers(handleLogout, ["prevent"])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  name: "la-power-off-solid",
                                  class: "icon",
                                  hover: "true",
                                  animation: "wrench"
                                }),
                                _createTextVNode(),
                                (expand.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_94, "Cerrar Sesión"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _hoisted_95
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_101, [
                      (expand.value)
                        ? (_openBlock(), _createBlock(AuthBtn, { key: 0 }))
                        : _createCommentVNode("", true)
                    ]))
              ]))
            : _createCommentVNode("", true)
        ], 34))
      : _createCommentVNode("", true),
    (_unref(windowWidth) <= 950)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass({ animate: true, isOpen: _unref(storeMenu).isOpen, isClose: !_unref(storeMenu).isOpen })
        }, [
          _hoisted_102,
          (_unref(store).token)
            ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                _createElementVNode("h5", _hoisted_104, [
                  _hoisted_105,
                  _createTextVNode(_toDisplayString(_unref(store).email), 1),
                  _hoisted_106
                ]),
                _hoisted_107
              ]))
            : _createCommentVNode("", true),
          _hoisted_108,
          _createElementVNode("nav", null, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'home' },
                  class: "link",
                  onClick: _unref(storeMenu).toggleMenu
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      name: "md-home-sharp",
                      class: "icon",
                      hover: "true",
                      animation: "wrench"
                    }),
                    _createTextVNode(" Inicio ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: _unref(main).SCHOOL_URL,
                  target: "_blank",
                  class: "link",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(storeMenu).toggleMenu && _unref(storeMenu).toggleMenu(...args)))
                }, [
                  _createVNode(_component_v_icon, {
                    name: "ai-ads",
                    class: "icon",
                    hover: "true",
                    animation: "wrench"
                  }),
                  _createTextVNode(" Conoce el Centro ")
                ], 8, _hoisted_109)
              ]),
              (_unref(main).has_module_news)
                ? (_openBlock(), _createElementBlock("li", _hoisted_110, [
                    _createVNode(_component_RouterLink, {
                      to: { name: 'notifications' },
                      class: "link",
                      onClick: _unref(storeMenu).toggleMenu
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          name: "io-newspaper-sharp",
                          class: "icon",
                          hover: "true",
                          animation: "wrench"
                        }),
                        _createTextVNode(" Noticias Escuelas Ave María ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_unref(main).has_module_news)
                ? (_openBlock(), _createElementBlock("li", _hoisted_111, [
                    _createVNode(_component_RouterLink, {
                      to: { name: 'agenda' },
                      class: "link",
                      onClick: _unref(storeMenu).toggleMenu
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          name: "bi-calendar3",
                          class: "icon",
                          hover: "true",
                          animation: "wrench"
                        }),
                        _createTextVNode(" Agenda ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_unref(main).has_module_roadmap)
                ? (_openBlock(), _createElementBlock("li", _hoisted_112, [
                    _createVNode(_component_RouterLink, {
                      to: { name: 'roadmaps' },
                      class: "link",
                      onClick: _unref(storeMenu).toggleMenu
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          name: "md-route-twotone",
                          class: "icon",
                          hover: "true",
                          animation: "wrench"
                        }),
                        _createTextVNode(" Itinerarios Formativos ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_unref(main).has_module_course)
                ? (_openBlock(), _createElementBlock("li", _hoisted_113, [
                    _createVNode(_component_RouterLink, {
                      to: { name: 'courses' },
                      class: "link",
                      onClick: _unref(storeMenu).toggleMenu
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          name: "co-education",
                          class: "icon",
                          hover: "true",
                          animation: "wrench"
                        }),
                        _createTextVNode(" Cursos Formativos")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_unref(main).has_module_certification)
                ? (_openBlock(), _createElementBlock("li", _hoisted_114, [
                    _createVNode(_component_RouterLink, {
                      to: { name: 'certifications' },
                      class: "link",
                      onClick: _unref(storeMenu).toggleMenu
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          name: "gi-diploma",
                          class: "icon",
                          hover: "true",
                          animation: "wrench"
                        }),
                        _createTextVNode(" Certificaciones ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_unref(main).has_module_bootcamp)
                ? (_openBlock(), _createElementBlock("li", _hoisted_115, [
                    _createVNode(_component_RouterLink, {
                      to: { name: 'bootcamp' },
                      class: "link",
                      onClick: _unref(storeMenu).toggleMenu
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          name: "md-developermode",
                          class: "icon",
                          hover: "true",
                          animation: "wrench"
                        }),
                        _createTextVNode(" BootCamps ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_unref(main).has_module_webinar)
                ? (_openBlock(), _createElementBlock("li", _hoisted_116, [
                    _createVNode(_component_RouterLink, {
                      to: { name: 'webinar' },
                      class: "link",
                      onClick: _unref(storeMenu).toggleMenu
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          name: "fa-laptop-code",
                          class: "icon",
                          hover: "true",
                          animation: "wrench"
                        }),
                        _createTextVNode(" Webinars ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_unref(main).has_module_challenge)
                ? (_openBlock(), _createElementBlock("li", _hoisted_117, [
                    _createVNode(_component_RouterLink, {
                      to: { name: 'challens' },
                      class: "link",
                      onClick: _unref(storeMenu).toggleMenu
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          name: "bi-cast",
                          class: "icon",
                          hover: "true",
                          animation: "wrench"
                        }),
                        _createTextVNode(" Reto de la Semana ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_unref(main).has_module_manual)
                ? (_openBlock(), _createElementBlock("li", _hoisted_118, [
                    _createVNode(_component_RouterLink, {
                      to: { name: 'bookspdf' },
                      class: "link",
                      onClick: _unref(storeMenu).toggleMenu
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          name: "bi-book-half",
                          class: "icon",
                          hover: "true",
                          animation: "wrench"
                        }),
                        _createTextVNode("Manuales ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_unref(main).has_module_exercise)
                ? (_openBlock(), _createElementBlock("li", _hoisted_119, [
                    _createVNode(_component_RouterLink, {
                      to: { name: 'ejercicios' },
                      class: "link",
                      onClick: _unref(storeMenu).toggleMenu
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          name: "md-librarybooks-round",
                          class: "icon",
                          hover: "true",
                          animation: "wrench"
                        }),
                        _createTextVNode(" Ejercicios")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: `mailto:${_unref(main).EMAIL_ADMINISTRATION}`,
                  class: "link",
                  target: "_blank"
                }, [
                  _createVNode(_component_v_icon, {
                    name: "md-supportagent-twotone",
                    class: "icon",
                    hover: "true",
                    animation: "wrench"
                  }),
                  _hoisted_121
                ], 8, _hoisted_120)
              ]),
              (_unref(main).has_module_faqs)
                ? (_openBlock(), _createElementBlock("li", _hoisted_122, [
                    _createVNode(_component_RouterLink, {
                      to: { name: 'faqs' },
                      class: "link",
                      onClick: _unref(storeMenu).toggleMenu
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          name: "bi-question-square",
                          class: "icon",
                          hover: "true",
                          animation: "wrench"
                        }),
                        _createTextVNode(" FAQs")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_unref(main).has_module_shop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_123))
            : _createCommentVNode("", true),
          (_unref(main).has_module_shop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                _hoisted_125,
                _createElementVNode("nav", null, [
                  _createElementVNode("ul", null, [
                    (_unref(main).has_module_class)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_126, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'teacher' },
                            class: "link",
                            onClick: _unref(storeMenu).toggleMenu
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "fa-portrait",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(" Clases En Vivo ")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(main).has_module_bookshop)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_127, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'bookshop' },
                            class: "link",
                            onClick: _unref(storeMenu).toggleMenu
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "bi-book-fill",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(" Librería ")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(main).has_module_shop)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_128, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'shop' },
                            class: "link",
                            onClick: _unref(storeMenu).toggleMenu
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "hi-shopping-cart",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(" Tienda ")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_129,
          (_unref(main).has_module_questions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                _hoisted_131,
                _createElementVNode("nav", null, [
                  _createElementVNode("ul", null, [
                    (_unref(main).has_module_questions)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_132, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'forum' },
                            class: "link",
                            onClick: _unref(storeMenu).toggleMenu
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "bi-question-circle-fill",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(" Dudas y Preguntas ")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(store).token && _unref(main).has_module_my_questions)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_133, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'my-questions' },
                            class: "link",
                            onClick: _unref(storeMenu).toggleMenu
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "si-dialogflow",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(" Mis Preguntas ")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(main).has_module_last_questions)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_134, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'forum-latest-questions' },
                            class: "link",
                            onClick: _unref(storeMenu).toggleMenu
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "md-lineweight-twotone",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(" Últimas Preguntas ")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_135,
          (_unref(main).has_module_employment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                _hoisted_137,
                _createElementVNode("nav", null, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'job-offering' },
                        class: "link",
                        onClick: _unref(storeMenu).toggleMenu
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "md-workhistory",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Ofertas de Empleo")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    (_unref(store).token)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_138, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'job-profile' },
                            class: "link",
                            onClick: _unref(storeMenu).toggleMenu
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "bi-person-workspace",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(" Mi Perfil de Empleo")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(main).has_module_practice)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_139, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'project-offering' },
                            class: "link",
                            onClick: _unref(storeMenu).toggleMenu
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "io-book",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(" Ofertas de Prácticas ")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(store).token)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_140, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'my-candidatures' },
                            class: "link",
                            onClick: _unref(storeMenu).toggleMenu
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "gi-tabletop-players",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode(" Mis Candidaturas")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_141,
          (_unref(store).token && _unref(main).has_module_social)
            ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                _hoisted_143,
                _createElementVNode("nav", null, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'my-wall' },
                        class: "link",
                        onClick: _unref(storeMenu).toggleMenu
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "si-coderwall",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Mi Muro ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'hall-of-fame' },
                        class: "link",
                        onClick: _unref(storeMenu).toggleMenu
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "md-stars-round",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Salón De La Fama ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'messages' },
                        class: "link",
                        onClick: _unref(storeMenu).toggleMenu
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "ri-message-2-fill",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Mensajería ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'friends' },
                        class: "link",
                        onClick: _unref(storeMenu).toggleMenu
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "fa-user-friends",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Mis Amigos ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'social-profile-edit' },
                        class: "link",
                        onClick: _unref(storeMenu).toggleMenu
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "fa-user-edit",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Gestionar Mi Canal ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'my-reputation' },
                        class: "link",
                        onClick: _unref(storeMenu).toggleMenu
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "ri-medal-fill",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Mi Reputación ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    (_unref(main).has_module_discord)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_144, [
                          _createElementVNode("a", {
                            href: "https://discord.com/invite/D6CTQyrf9Q",
                            target: "blank",
                            class: "link",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(storeMenu).toggleMenu && _unref(storeMenu).toggleMenu(...args)))
                          }, [
                            _createVNode(_component_v_icon, {
                              name: "bi-discord",
                              class: "icon",
                              hover: "true",
                              animation: "wrench"
                            }),
                            _createTextVNode(" Cafetería del Campus ")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_145,
          (_unref(store).token)
            ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                _hoisted_147,
                _createElementVNode("nav", null, [
                  _createElementVNode("ul", null, [
                    (userFull.value.paypal_id && _unref(main).monetization_type === 'subscription')
                      ? (_openBlock(), _createElementBlock("li", _hoisted_148, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'count-prodev' },
                            class: "link",
                            onClick: _unref(storeMenu).toggleMenu
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "md-librarybooks-round",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode("Mi suscripción ")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (userFull.value.paypal_id && _unref(main).monetization_type === 'subscription')
                      ? (_openBlock(), _createElementBlock("li", _hoisted_149, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'register-free' },
                            class: "link",
                            onClick: _unref(storeMenu).toggleMenu
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "md-librarybooks-round",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode("Comenzar Prueba Gratuita ")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(main).monetization_type == 'pay_per_course')
                      ? (_openBlock(), _createElementBlock("li", _hoisted_150, [
                          _createVNode(_component_RouterLink, {
                            to: { name: 'shop-course' },
                            class: "link",
                            onClick: _unref(storeMenu).toggleMenu
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                name: "fa-shopping-bag",
                                class: "icon",
                                hover: "true",
                                animation: "wrench"
                              }),
                              _createTextVNode("Mis Compras ")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (!loading.value && _unref(main).has_module_portfolio)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_151, [
                          (_unref(store).token)
                            ? (_openBlock(), _createBlock(_component_RouterLink, {
                                key: 0,
                                to: { name: 'portfolio2', params: { id: userId.value } },
                                class: "link",
                                onClick: _unref(storeMenu).toggleMenu,
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    name: "fa-portrait",
                                    class: "icon",
                                    hover: "true",
                                    animation: "wrench"
                                  }),
                                  _createTextVNode("Mi Portfolio")
                                ]),
                                _: 1
                              }, 8, ["to", "onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'my-roadmaps' },
                        class: "link",
                        onClick: _unref(storeMenu).toggleMenu
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "md-route-twotone",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Mis Hojas de Ruta")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'my-courses' },
                        class: "link",
                        onClick: _unref(storeMenu).toggleMenu
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "co-education",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Mis Cursos Formativos ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'my-diplomas' },
                        class: "link",
                        onClick: _unref(storeMenu).toggleMenu
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "gi-diploma",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Mis Diplomas ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'my-notes' },
                        class: "link",
                        onClick: _unref(storeMenu).toggleMenu
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "md-notes",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Mis Apuntes")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'my-favs' },
                        class: "link",
                        onClick: _unref(storeMenu).toggleMenu
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "md-playlesson-round",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Mis Lecciones Favoritas")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'my-laters' },
                        class: "link",
                        onClick: _unref(storeMenu).toggleMenu
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "md-watchlater",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Ver Más Tarde ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'codebites-saved' },
                        class: "link",
                        onClick: _unref(storeMenu).toggleMenu
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "bi-file-code-fill",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Shorts Guardados ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'codeposts-saved' },
                        class: "link",
                        onClick: _unref(storeMenu).toggleMenu
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "bi-file-post",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Posts Guardados ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'profile' },
                        class: "link",
                        onClick: _unref(storeMenu).toggleMenu
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "la-user-circle",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Mi Perfil ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_RouterLink, {
                        to: "#",
                        class: "link",
                        onClick: _withModifiers(handleLogout, ["prevent"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: "la-power-off-solid",
                            class: "icon",
                            hover: "true",
                            animation: "wrench"
                          }),
                          _createTextVNode(" Cerrar Sesión ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_152, [
                _createVNode(AuthBtn, {
                  onClick: _unref(storeMenu).toggleMenu
                }, null, 8, ["onClick"]),
                _hoisted_153
              ]))
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})